<script setup lang="ts">

import { computed, ref, watch } from "vue";
import { formatting, useRegistry } from "@hantera/portal-app";

const props = defineProps<{
  image?: string
  productNumber: string
}>()

const registry = useRegistry();

const template = await registry.get('portal/general/orderLineImageUrlTemplate');

const imageUrl = computed(() => {

  if (typeof template === 'string') {
    return formatting.string(template, {
      image: props.image,
      productNumber: props.productNumber,
    });
  }

  return props.image;
});

const displayFallbackImage = ref(!props.image);

function onImageError() {
  displayFallbackImage.value = true
}

watch(() => props.image, () => {
  if (!props.image) {
    displayFallbackImage.value = true;
  }
})

</script>

<template>
  <div class="order-line-image-link box" v-if="displayFallbackImage">

  </div>
  <a :href="imageUrl" target="_blank" class="order-line-image-link box" v-else>
    <img
      :src="imageUrl"
      class="order-line-image"
      @error="onImageError"
      :alt="productNumber"
    />
  </a>
</template>

<style scoped>
.order-line-image-link {
  grid-row: span 2;
  display: block;
  padding-bottom: 100%;
  position: relative;
}

.order-line-image {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>